module.exports = __webpack_public_path__ + "img/87bf3e5586ba08c7322b589d809f7ce5.0bb6ab66.png";